import { useEffect, useState } from "react";
import { LightBox, Modal, ModalContent, ModalFooter } from "./Style";
import { style } from "./StyleType";
import TmpButtonIconCustom from "../TmpButtonIconCustom/TmpButtonIconCustom";
import { ReactComponent as IconCancelar } from "../../../assets/icons/cancelar.svg";
import TmpButtonCustom from "../TmpButtonCustom/TmpButtonCustom";
import TmpButtonGroupCustom from "../TmpButtonGroupCustom/TmpButtonGroupCustom";

interface TmpModalCustomProps {

    isOpened: boolean;
    isDoubleAction: boolean;
    showButtomClose?: boolean;
    labelPrimary?: string;
    labelSecondary?: string;
    handleConfirm?: () => void;
    handleCancel?: () => void;
    handleClose?: () => void;
    children: React.ReactNode;
    size: "md" | "lg" | "sm";
    ariaLabelCloseModal?: string;
    closeOnClickOutside?: boolean;
}


export default function TmpModalCustom(props: TmpModalCustomProps) {

    const [_isOpened, setOpen] = useState(props.isOpened);

    useEffect(() => {
        setOpen(props.isOpened);
    }, [props.isOpened]);

    // Events
    const _handleClose = () => {
        setOpen(false);
        if (typeof props.handleClose === "function") {
            props.handleClose();
        }
    };

    const _handleConfirm = () => {
        if (typeof props.handleConfirm === "function") {
            props.handleConfirm();
        }
    };

    const _handleCancel = () => {
        _handleClose();
        if (typeof props.handleCancel === "function") {
            props.handleCancel();
        }
    };

    const handleOutsideClose = (e: any) => {
        if (props.closeOnClickOutside) {
            if (e.target.id === "light-box") {
                _handleClose();
            }
        }
    };

    // Passing style props to styled component
    LightBox.defaultProps = style;
    Modal.defaultProps = style;
    ModalContent.defaultProps = style;
    ModalFooter.defaultProps = style;

    return (
        <>
            {_isOpened}
            <LightBox id="light-box" isOpened={_isOpened} onClick={handleOutsideClose}>
                <Modal id={`modal-${props.size}`} isOpened={_isOpened} size={props.size}>
                    <ModalContent id="modal-content">
                        {props.showButtomClose === true ?
                            <TmpButtonIconCustom
                                icon={<IconCancelar />}
                                type="primary"
                                typeButton="button"
                                size="lg"
                                ariaLabel={props.ariaLabelCloseModal}
                                handleClick={_handleClose}
                            />
                            : null}

                        {props.children}
                    </ModalContent>
                    {(typeof props.handleCancel === "function" ||
                        typeof props.handleConfirm === "function") && (
                            <ModalFooter id="modal-footer" size={props.size}>
                                {props.isDoubleAction && props.labelPrimary && props.labelSecondary ? (
                                    <TmpButtonGroupCustom
                                        size="sm"
                                        labelPrimary={props.labelPrimary}
                                        labelSecondary={props.labelSecondary}
                                        handleClickPrimary={_handleConfirm}
                                        handleClickSecondary={_handleCancel}
                                    />
                                ) : (
                                    <TmpButtonCustom size="sm" handleClick={_handleConfirm} type="primary" typeButton="button">
                                        {props.labelPrimary}
                                    </TmpButtonCustom>
                                )}
                            </ModalFooter>
                        )}
                </Modal>
            </LightBox>
        </>
    );
}

